import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { useTranslation } from "react-i18next";
import { NumericFormat } from "react-number-format";
import { re } from "mathjs";
import { func } from "prop-types";

export default function IncomeStatement({ data, dataChange }) {
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.action.hover,
      borderSpacing: "10px",
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));
  const [totalCurrentAssets, setTotalCurrentAssets] = useState(
    calculateTotalCurrentAssets()
  );
  const [totalCurrentAssets1, setTotalCurrentAssets1] = useState(
    calculateTotalCurrentAssets1()
  );
  const [totalCurrentAssets2, setTotalCurrentAssets2] = useState(
    calculateTotalCurrentAssets2()
  );
  const [totalCurrentAssets3, setTotalCurrentAssets3] = useState(
    calculateTotalCurrentAssets3()
  );
  const [totalCurrent3, setTotalCurrent3] = useState(calculateFld3());
  const [totalCurrent1, setTotalCurrent1] = useState(calculateFld1());
  const [totalCurrent2, setTotalCurrent2] = useState(calculateFld2());
  const [totalCurrent, setTotalCurrent] = useState(calculateFld1());
  const [totalCur3, setTotalCurt3] = useState(calculateFlid3());
  const [totalCur1, setTotalCurt1] = useState(calculateFlid1());
  const [totalCur2, setTotalCurt2] = useState(calculateFlid2());
  const [totalCur, setTotalCurt] = useState(calculateFlid());
  const [totalCurtt, setTotalCurtt] = useState(calculateFlied());
  const [totalCurtt1, setTotalCurtt1] = useState(calculateFlied1());
  const [totalCurtt2, setTotalCurtt2] = useState(calculateFlied2());
  const [totalCurtt3, setTotalCurtt3] = useState(calculateFlied3());

  const [Ebita0, setEbita0] = useState("");
  const [Ebita1, setEbita1] = useState("");
  const [Ebita2, setEbita2] = useState("");
  const [Ebita3, setEbita3] = useState("");

  const [currentlyFocused, setCurrentlyFocused] = useState(null);

  function toNumber(data) {
    if (data == null || data == "") {
      return 0;
    }

    return parseInt(data)
    // return isNaN(data) ? parseFloat(data.replace(/,/g, "")) : parseFloat(data);
  }
  function calculateEbitda() {
    let ebiData =
      totalCur +
      
      toNumber(data[0]["depreciationAndAmortization"]) +
      toNumber(data[0]["interestExpense"]);
    return ebiData;
  }
  function calculateEbitda1() {
    let ebiData =
      totalCur1 +
      toNumber(data[1]["depreciationAndAmortization"]) +
      toNumber(data[1]["interestExpense"]);
    return ebiData;
  }
  function calculateEbitda2() {
    let ebiData =
      totalCur2 +
      toNumber(data[2]["depreciationAndAmortization"]) +
      toNumber(data[2]["interestExpense"]);
    return ebiData;
  }
  function calculateEbitda3() {
    let ebiData =
      totalCur3 +
      toNumber(data[3]["depreciationAndAmortization"]) +
      toNumber(data[3]["interestExpense"]);
    return ebiData;
  }
  function calculateFlied() {
    const constructionRevenues = toNumber(data[0]?.incomeTaxExpenseBenifit);
    const difference = constructionRevenues;
    return totalCur - difference;
  }

  function calculateFlied1() {
    // const constructionRevenues = parseFloat(data[1]?.incomeTaxExpenseBenifit) || 0;

    const constructionRevenues = toNumber(data[1]?.incomeTaxExpenseBenifit);

    const difference = constructionRevenues;

    return totalCur1 - difference;
  }

  function calculateFlied2() {
    const constructionRevenues = toNumber(data[2]?.incomeTaxExpenseBenifit);

    const difference = constructionRevenues;

    return totalCur2 - difference;
  }

  function calculateFlied3() {
    const constructionRevenues = toNumber(data[3]?.incomeTaxExpenseBenifit);

    const difference = constructionRevenues;

    return totalCur3 - difference;
  }
  function calculateFlid() {
   
    const constructionRevenues = toNumber(data[0]?.operatingIncome);
    const constructionDirectCosts = toNumber(data[0]?.otherIncomeDeductions);

    const difference = constructionDirectCosts;
    return difference + totalCurrent;
  }
  function calculateFlid1() {
    const constructionRevenues = toNumber(data[1]?.operatingIncome);
    const constructionDirectCosts = toNumber(data[1]?.otherIncomeDeductions);

    const difference = constructionDirectCosts;

    return difference + totalCurrent1;
  }
  function calculateFlid2() {
    const constructionDirectCosts = toNumber(data[2]?.otherIncomeDeductions);

    const difference = constructionDirectCosts;

    return difference + totalCurrent2;
  }
  function calculateFlid3() {
    const constructionRevenues = toNumber(data[3]?.operatingIncome);
    const constructionDirectCosts = toNumber(data[3]?.otherIncomeDeductions);

    const difference = constructionDirectCosts;

    return difference + totalCurrent3;
  }

  function calculateFld() {
    const constructionRevenues = toNumber(
      data[0]?.nonConstructionGrossProfitLoss
    );
    const constructionDirectCosts = toNumber(
      data[0]?.generalAndAdministrativeExpenses
    );

    const difference = constructionRevenues - constructionDirectCosts;

    return difference + totalCurrentAssets;
  }
  function calculateFld1() {
    const constructionRevenues = toNumber(
      data[1]?.nonConstructionGrossProfitLoss
    );
    const constructionDirectCosts = toNumber(
      data[1]?.generalAndAdministrativeExpenses
    );

    const difference = constructionRevenues - constructionDirectCosts;

    return difference + totalCurrentAssets1;
  }
  function calculateFld2() {
    const constructionRevenues = toNumber(
      data[2]?.nonConstructionGrossProfitLoss
    );
    const constructionDirectCosts = toNumber(
      data[2]?.generalAndAdministrativeExpenses
    );

    const difference = constructionRevenues - constructionDirectCosts;

    return difference + totalCurrentAssets2;
  }
  function calculateFld3() {
    const constructionRevenues = toNumber(
      data[3]?.nonConstructionGrossProfitLoss
    );
    const constructionDirectCosts = toNumber(
      data[3]?.generalAndAdministrativeExpenses
    );

    const difference = constructionRevenues - constructionDirectCosts;

    return difference + totalCurrentAssets3;
  }

  function calculateTotalCurrentAssets() {
    const constructionRevenues = toNumber(data[0]?.constructionRevenues);
    const constructionDirectCosts = toNumber(data[0]?.constructionDirectCosts);

    const difference = constructionRevenues - constructionDirectCosts;

    return difference;
  }
  function calculateTotalCurrentAssets1() {
    const constructionRevenues = toNumber(data[1]?.constructionRevenues);
    const constructionDirectCosts = toNumber(data[1]?.constructionDirectCosts);

    const difference = constructionRevenues - constructionDirectCosts;

    return difference;
  }
  function calculateTotalCurrentAssets2() {
    const constructionRevenues = toNumber(data[2]?.constructionRevenues);
    const constructionDirectCosts = toNumber(data[2]?.constructionDirectCosts);

    const difference = constructionRevenues - constructionDirectCosts;

    return difference;
  }
  function calculateTotalCurrentAssets3() {
    const constructionRevenues = toNumber(data[3]?.constructionRevenues);
    const constructionDirectCosts = toNumber(data[3]?.constructionDirectCosts);

    const difference = constructionRevenues - constructionDirectCosts;

    return difference;
  }
  useEffect(() => {
    setTotalCurrentAssets(calculateTotalCurrentAssets());
    setTotalCurrentAssets1(calculateTotalCurrentAssets1());
    setTotalCurrentAssets2(calculateTotalCurrentAssets2());
    setTotalCurrentAssets3(calculateTotalCurrentAssets3());
    setTotalCurrent3(calculateFld3());
    setTotalCurrent2(calculateFld2());
    setTotalCurrent1(calculateFld1());
    setTotalCurrent(calculateFld());
    setTotalCurtt(calculateFlied());
    setTotalCurtt1(calculateFlied1());
    setTotalCurtt2(calculateFlied2());
    setTotalCurtt3(calculateFlied3());
    setTotalCurt(calculateFlid());
    setTotalCurt1(calculateFlid1());
    setTotalCurt2(calculateFlid2());
    setTotalCurt3(calculateFlid3());
    // setTotalCurt(calculateFlid());
    // setTotalCurt1(calculateFlid1());
    // setTotalCurt2(calculateFlid2());
    // setTotalCurt3(calculateFlid3());
    // setTotalAssets(calculateTotalAssets());
    // setTotalAssets1(calculateTotalAssets1());
    // setTotalAssets2(calculateTotalAssets2());
    // setTotalAssets3(calculateTotalAssets3());
    // settotalLiabilities(calculatetotalLiabilities());
    // settotalLiabilities1(calculatetotalLiabilities1());
    // settotalLiabilities2(calculatetotalLiabilities2());
    // settotalLiabilities3(calculatetotalLiabilities3());
  }, [data]);

  useEffect(() => {
    setTotalCurrent3(calculateFld3());
    setTotalCurrent2(calculateFld2());
    setTotalCurrent1(calculateFld1());
    setTotalCurrent(calculateFld());
  }, [
    totalCurrentAssets,
    totalCurrentAssets1,
    totalCurrentAssets2,
    totalCurrentAssets3,
  ]);

  useEffect(() => {
    setTotalCurt(calculateFlid());
    setTotalCurt1(calculateFlid1());
    setTotalCurt2(calculateFlid2());
    setTotalCurt3(calculateFlid3());
  }, [totalCurrent, totalCurrent1, totalCurrent2, totalCurrent3]);

  useEffect(() => {
   
    setEbita0(calculateEbitda());
    setEbita1(calculateEbitda1());
    setEbita2(calculateEbitda2());
    setEbita3(calculateEbitda3());
  }, [totalCur, totalCur1, totalCur2, totalCur3]);

  const realonlyField = [
    "constructionGrossProfit",
    "operatingIncome",
    "earningBeforeTaxes",
    "netIncome",
    "ebidta",
  ];
  const headColumns = [
    "constructionRevenues",
    "constructionDirectCosts",
    "constructionGrossProfit",
    "nonConstructionGrossProfitLoss",
    "generalAndAdministrativeExpenses",
    "operatingIncome",
    "otherIncomeDeductions",
    "earningBeforeTaxes",
    "incomeTaxExpenseBenifit",
    "netIncome",
    "ebidta",
  ];

  const { t } = useTranslation();

  return (
    <div>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 700 }} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>&nbsp;</StyledTableCell>
              <StyledTableCell align="right" className="text-muted">
                {"Current YTD"}
              </StyledTableCell>
              <StyledTableCell align="right" className="text-muted">
                {"Previous Year"}{" "}
              </StyledTableCell>
              <StyledTableCell align="right" className="text-muted">
                {"2 Years Previous"}
              </StyledTableCell>
              <StyledTableCell align="right" className="text-muted">
                {"3 Years Previous"}&nbsp;
              </StyledTableCell>
            </TableRow>
          </TableHead>

          {headColumns.map((r, index) => (
            <React.Fragment key={index}>
              <TableRow
                hidden={realonlyField.indexOf(r) !== -1}
                sx={{
                  backgroundColor:
                    realonlyField.indexOf(r) != -1 ? " #F2F4F7" : "#fff",
                }}
              >
                <StyledTableCell>{t(r)}</StyledTableCell>
                <StyledTableCell align="right" className="text-muted">
                  <NumericFormat
                    customInput={TextField}
                    decimalScale={0}
                    thousandSeparator=","
                    autoFocus={`values1${index}` === currentlyFocused}
                    onFocus={() => setCurrentlyFocused(`values1${index}`)}
                    disabled={realonlyField.indexOf(r) != -1}
                    sx={{
                      "& legend": { display: "none" },
                      "& fieldset": { top: 0 },
                    }}
                    size="small"
                    id="outlined-basic"
                    value={data?.[0]?.[r]}
                    variant="outlined"
                    // onChange={(event) => {
                    //   dataChange(0, r, event.target.value);
                    // }}
                    onValueChange={(values) => {
                      dataChange(0, r, values.floatValue);
                    }}
                  />
                </StyledTableCell>
                <StyledTableCell align="right" className="text-muted">
                  <NumericFormat
                    customInput={TextField}
                    decimalScale={0}
                    thousandSeparator=","
                    autoFocus={`values2${index}` === currentlyFocused}
                    onFocus={() => setCurrentlyFocused(`values2${index}`)}
                    disabled={realonlyField.indexOf(r) != -1}
                    size="small"
                    id="outlined-basic"
                    sx={{
                      "& legend": { display: "none" },
                      "& fieldset": { top: 0 },
                    }}
                    value={data?.[1]?.[r]}
                    variant="outlined"
                    // onChange={(event) => {
                    //   dataChange(1, r, event.target.value);
                    // }}
                    onValueChange={(values) => {
                      dataChange(1, r, values.floatValue);
                    }}
                  />{" "}
                </StyledTableCell>
                <StyledTableCell align="right" className="text-muted">
                  <NumericFormat
                    customInput={TextField}
                    decimalScale={0}
                    thousandSeparator=","
                    autoFocus={`values3${index}` === currentlyFocused}
                    onFocus={() => setCurrentlyFocused(`values3${index}`)}
                    disabled={realonlyField.indexOf(r) != -1}
                    size="small"
                    id="outlined-basic"
                    sx={{
                      "& legend": { display: "none" },
                      "& fieldset": { top: 0 },
                    }}
                    value={data?.[2]?.[r]}
                    variant="outlined"
                    // onChange={(event) => {
                    //   dataChange(2, r, event.target.value);
                    // }}
                    onValueChange={(values) => {
                      dataChange(2, r, values.floatValue);
                    }}
                  />
                </StyledTableCell>
                <StyledTableCell align="right" className="text-muted">
                  <NumericFormat
                    customInput={TextField}
                    decimalScale={0}
                    thousandSeparator=","
                    autoFocus={`values4${index}` === currentlyFocused}
                    onFocus={() => setCurrentlyFocused(`values4${index}`)}
                    disabled={realonlyField.indexOf(r) != -1}
                    size="small"
                    id="outlined-basic"
                    sx={{
                      "& legend": { display: "none" },
                      "& fieldset": { top: 0 },
                    }}
                    value={data?.[3]?.[r]}
                    variant="outlined"
                    // onChange={(event) => {
                    //   dataChange(3, r, event.target.value);
                    // }}
                    onValueChange={(values) => {
                      dataChange(3, r, values.floatValue);
                    }}
                  />
                </StyledTableCell>
              </TableRow>
              {r === "constructionGrossProfit" && (
                <TableRow sx={{ backgroundColor: "#F2F4F7" }}>
                  <StyledTableCell>{t(r)}</StyledTableCell>
                  <StyledTableCell align="right" className="text-muted">
                    <NumericFormat
                      customInput={TextField}
                      decimalScale={0}
                      thousandSeparator=","
                      size="small"
                      id="outlined-basic"
                      value={calculateTotalCurrentAssets()} // Provide the calculated value here
                      variant="outlined"
                      disabled // Disable editing of the calculated value
                    />
                  </StyledTableCell>
                  <StyledTableCell align="right" className="text-muted">
                    {" "}
                    <NumericFormat
                      customInput={TextField}
                      decimalScale={0}
                      thousandSeparator=","
                      size="small"
                      id="outlined-basic"
                      value={calculateTotalCurrentAssets1()} // Provide the calculated value here
                      variant="outlined"
                      disabled // Disable editing of the calculated value
                    />
                  </StyledTableCell>
                  <StyledTableCell align="right" className="text-muted">
                    {" "}
                    <NumericFormat
                      customInput={TextField}
                      decimalScale={0}
                      thousandSeparator=","
                      size="small"
                      id="outlined-basic"
                      value={calculateTotalCurrentAssets2()} // Provide the calculated value here
                      variant="outlined"
                      disabled // Disable editing of the calculated value
                    />
                  </StyledTableCell>
                  <StyledTableCell align="right" className="text-muted">
                    {" "}
                    <NumericFormat
                      customInput={TextField}
                      decimalScale={0}
                      thousandSeparator=","
                      size="small"
                      id="outlined-basic"
                      value={calculateTotalCurrentAssets3()} // Provide the calculated value here
                      variant="outlined"
                      disabled // Disable editing of the calculated value
                    />
                  </StyledTableCell>
                </TableRow>
              )}
              {r === "operatingIncome" && (
                <TableRow sx={{ backgroundColor: "#F2F4F7" }}>
                  <StyledTableCell>{t(r)}</StyledTableCell>
                  <StyledTableCell align="right" className="text-muted">
                    <NumericFormat
                      customInput={TextField}
                      decimalScale={0}
                      thousandSeparator=","
                      size="small"
                      id="outlined-basic"
                      value={calculateFld()} // Provide the calculated value here
                      variant="outlined"
                      disabled // Disable editing of the calculated value
                    />
                  </StyledTableCell>
                  <StyledTableCell align="right" className="text-muted">
                    {" "}
                    <NumericFormat
                      customInput={TextField}
                      decimalScale={0}
                      thousandSeparator=","
                      size="small"
                      id="outlined-basic"
                      value={calculateFld1()} // Provide the calculated value here
                      variant="outlined"
                      disabled // Disable editing of the calculated value
                    />
                  </StyledTableCell>
                  <StyledTableCell align="right" className="text-muted">
                    {" "}
                    <NumericFormat
                      customInput={TextField}
                      decimalScale={0}
                      thousandSeparator=","
                      size="small"
                      id="outlined-basic"
                      value={calculateFld2()} // Provide the calculated value here
                      variant="outlined"
                      disabled // Disable editing of the calculated value
                    />
                  </StyledTableCell>
                  <StyledTableCell align="right" className="text-muted">
                    {" "}
                    <NumericFormat
                      customInput={TextField}
                      decimalScale={0}
                      thousandSeparator=","
                      size="small"
                      id="outlined-basic"
                      value={calculateFld3()} // Provide the calculated value here
                      variant="outlined"
                      disabled // Disable editing of the calculated value
                    />
                  </StyledTableCell>
                </TableRow>
              )}
              {r === "earningBeforeTaxes" && (
                <TableRow sx={{ backgroundColor: "#F2F4F7" }}>
                  <StyledTableCell>{t(r)}</StyledTableCell>
                  <StyledTableCell align="right" className="text-muted">
                    <NumericFormat
                      customInput={TextField}
                      decimalScale={0}
                      thousandSeparator=","
                      size="small"
                      id="outlined-basic"
                      value={calculateFlid()} // Provide the calculated value here
                      variant="outlined"
                      disabled // Disable editing of the calculated value
                    />
                  </StyledTableCell>
                  <StyledTableCell align="right" className="text-muted">
                    {" "}
                    <NumericFormat
                      customInput={TextField}
                      decimalScale={0}
                      thousandSeparator=","
                      size="small"
                      id="outlined-basic"
                      value={calculateFlid1()} // Provide the calculated value here
                      variant="outlined"
                      disabled // Disable editing of the calculated value
                    />
                  </StyledTableCell>
                  <StyledTableCell align="right" className="text-muted">
                    {" "}
                    <NumericFormat
                      customInput={TextField}
                      decimalScale={0}
                      thousandSeparator=","
                      size="small"
                      id="outlined-basic"
                      value={calculateFlid2()} // Provide the calculated value here
                      variant="outlined"
                      disabled // Disable editing of the calculated value
                    />
                  </StyledTableCell>
                  <StyledTableCell align="right" className="text-muted">
                    {" "}
                    <NumericFormat
                      customInput={TextField}
                      decimalScale={0}
                      thousandSeparator=","
                      size="small"
                      id="outlined-basic"
                      value={calculateFlid3()} // Provide the calculated value here
                      variant="outlined"
                      disabled // Disable editing of the calculated value
                    />
                  </StyledTableCell>
                </TableRow>
              )}
              {r === "netIncome" && (
                <TableRow sx={{ backgroundColor: "#F2F4F7" }}>
                  <StyledTableCell>{t(r)}</StyledTableCell>
                  <StyledTableCell align="right" className="text-muted">
                    <NumericFormat
                      customInput={TextField}
                      decimalScale={0}
                      thousandSeparator=","
                      size="small"
                      id="outlined-basic"
                      value={calculateFlied()} // Provide the calculated value here
                      variant="outlined"
                      disabled // Disable editing of the calculated value
                    />
                  </StyledTableCell>
                  <StyledTableCell align="right" className="text-muted">
                    {" "}
                    <NumericFormat
                      customInput={TextField}
                      decimalScale={0}
                      thousandSeparator=","
                      size="small"
                      id="outlined-basic"
                      value={calculateFlied1()} // Provide the calculated value here
                      variant="outlined"
                      disabled // Disable editing of the calculated value
                    />
                  </StyledTableCell>
                  <StyledTableCell align="right" className="text-muted">
                    {" "}
                    <NumericFormat
                      customInput={TextField}
                      decimalScale={0}
                      thousandSeparator=","
                      size="small"
                      id="outlined-basic"
                      value={calculateFlied2()} // Provide the calculated value here
                      variant="outlined"
                      disabled // Disable editing of the calculated value
                    />
                  </StyledTableCell>
                  <StyledTableCell align="right" className="text-muted">
                    {" "}
                    <NumericFormat
                      customInput={TextField}
                      decimalScale={0}
                      thousandSeparator=","
                      size="small"
                      id="outlined-basic"
                      value={calculateFlied3()} // Provide the calculated value here
                      variant="outlined"
                      disabled // Disable editing of the calculated value
                    />
                  </StyledTableCell>
                </TableRow>
              )}
              {r === "ebidta" && (
                <TableRow sx={{ backgroundColor: "#F2F4F7" }}>
                  <StyledTableCell>{t(r)}</StyledTableCell>
                  <StyledTableCell align="right" className="text-muted">
                    <NumericFormat
                      customInput={TextField}
                      decimalScale={0}
                      thousandSeparator=","
                      size="small"
                      id="outlined-basic"
                      // value={data[0]?.cebitda} // Provide the calculated value here
                      value={calculateEbitda()} // Provide the calculated value here
                      variant="outlined"
                      disabled // Disable editing of the calculated value
                    />
                  </StyledTableCell>
                  <StyledTableCell align="right" className="text-muted">
                    {" "}
                    <NumericFormat
                      customInput={TextField}
                      decimalScale={0}
                      thousandSeparator=","
                      size="small"
                      id="outlined-basic"
                      // value={data[1]?.cebitda} // Provide the calculated value here
                      value={calculateEbitda1()} // Provide the calculated value here
                      variant="outlined"
                      disabled // Disable editing of the calculated value
                    />
                  </StyledTableCell>
                  <StyledTableCell align="right" className="text-muted">
                    {" "}
                    <NumericFormat
                      customInput={TextField}
                      decimalScale={0}
                      thousandSeparator=","
                      size="small"
                      id="outlined-basic"
                      // value={data[2]?.cebitda} // Provide the calculated value here
                      value={calculateEbitda2()} // Provide the calculated value here
                      variant="outlined"
                      disabled // Disable editing of the calculated value
                    />
                  </StyledTableCell>
                  <StyledTableCell align="right" className="text-muted">
                    {" "}
                    <NumericFormat
                      customInput={TextField}
                      decimalScale={0}
                      thousandSeparator=","
                      size="small"
                      id="outlined-basic"
                      // value={data[3]?.cebitda} // Provide the calculated value here
                      value={calculateEbitda3()} // Provide the calculated value here
                      variant="outlined"
                      disabled // Disable editing of the calculated value
                    />
                  </StyledTableCell>
                </TableRow>
              )}
            </React.Fragment>
          ))}
        </Table>
      </TableContainer>
    </div>
  );
}
